import React from "react";

export default function Privacy() {
  return (
    <main className="min-h-screen bg-[#080b12] text-gray-200 px-5 py-24">
      <article className="max-w-4xl mx-auto">
        <p className="text-red-500 uppercase tracking-widest text-sm mb-4">
          Doriantelive // Legal
        </p>
        <h1 className="text-4xl font-bold text-white mb-4">
          Privacy Policy
        </h1>
        <p className="text-gray-400 mb-12">Effective October 28, 2026</p>

        <div className="space-y-8 leading-8">
          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">1. Overview</h2>
            <p>
              Doriantelive operates doriantelive.com, including Stream Control,
              member features, creator tools, and related services.
              This policy explains how we collect, use, and protect information.
            </p>
          </section>

          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">2. Information We Collect</h2>
            <p>
              Depending on the features used, we may process account identifiers,
              streaming channel information, usernames, authentication credentials,
              stream metadata, saved presets, and information voluntarily provided
              through the platform.
            </p>
            <p className="mt-3">
              Store features may process contact, shipping, and transaction
              information necessary to fulfill purchases.
            </p>
          </section>

          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">3. Connected Streaming Accounts</h2>
            <p>
              Stream Control supports connections to YouTube, Twitch, and Kick.
              Authorized connections allow the service to retrieve channel
              information and perform streaming management actions requested
              by the account holder.
            </p>
            <p className="mt-3">
              YouTube integration may access channel and broadcast details
              and update selected stream or video metadata, including titles,
              descriptions, categories, and tags.
            </p>
            <p className="mt-3">
              OAuth credentials are stored server-side, with sensitive tokens
              encrypted. Stream Control does not require your Google password.
            </p>
          </section>

          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">4. YouTube API Services</h2>
            <p>
              Stream Control uses YouTube API Services. Your use of YouTube
              features is also subject to the
              {" "}<a href="https://www.youtube.com/t/terms" className="text-red-400 underline" target="_blank" rel="noreferrer">YouTube Terms of Service</a>
              {" "}and the
              {" "}<a href="https://policies.google.com/privacy" className="text-red-400 underline" target="_blank" rel="noreferrer">Google Privacy Policy</a>.
            </p>
            <p className="mt-3">
              You can review or revoke authorization through
              {" "}<a href="https://myaccount.google.com/connections" className="text-red-400 underline" target="_blank" rel="noreferrer">Google Account Connections</a>.
            </p>
          </section>

          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">5. Use of Information</h2>
            <p>
              Information is used to authenticate members, maintain authorized
              platform connections, provide requested features, process orders,
              troubleshoot problems, and maintain service security.
            </p>
          </section>

          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">6. Storage and Third Parties</h2>
            <p>
              Doriantelive uses third-party hosting, database, storage,
              authentication, streaming, payment, and fulfillment services
              as necessary to operate its features.
            </p>
            <p className="mt-3">
              We do not sell connected YouTube account information or OAuth
              credentials to advertisers. No internet service can guarantee
              absolute security.
            </p>
          </section>

          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">7. Disconnecting and Data Requests</h2>
            <p>
              You can disconnect supported streaming integrations through
              Stream Control or revoke permissions directly through the
              relevant provider.
            </p>
            <p className="mt-3">
              For requests concerning access, correction, or deletion of
              personal information, contact
              {" "}<a href="mailto:mail@doriantelive.com" className="text-red-400 underline">mail@doriantelive.com</a>.
              Some information may be retained where necessary for legal,
              security, or transaction-record obligations.
            </p>
          </section>

          <section>
            <h2 className="text-2xl text-white font-semibold mb-3">8. Changes and Contact</h2>
            <p>
              This policy may be updated as the platform evolves.
              Questions can be directed to
              {" "}<a href="mailto:mail@doriantelive.com" className="text-red-400 underline">mail@doriantelive.com</a>.
            </p>
          </section>
        </div>
      </article>
    </main>
  );
}
